class TZUpsellColorsCart extends HTMLElement {
    constructor() {
        super();

        this.variantPickers = null;
    }

    connectedCallback() {
        this.initSwiper();

        this.variantPickers = this.querySelectorAll('.tz-size-picker');
        if(!this.variantPickers.length) return;

        this.variantPickers.forEach(variantPicker => this.initialiseVariantPicker(variantPicker));

        document.addEventListener('click', this.handleDocumentClick);
    }

    disconnectedCallback() {
        if (this.swiper) {
            this.swiper.destroy(true, true);
        }
    }

    initSwiper() {
        const slider = this.querySelector('.tz-upsell-colors__swiper');

        if (!slider) return;

        if (slider.swiper) {
            slider.swiper.destroy(true, true);
        }

        this.swiper = new Swiper(slider, {
            slidesPerView: "auto",
            spaceBetween: 10,
            watchOverflow: true,

            scrollbar: {
                el: '.tz-upsell-colors__scrollbar',
                draggable: true,
            }
        });
    }


    initialiseVariantPicker(picker) {
        const parent = picker.closest('.tz-upsell-color__card-wrapper');
        const atc = parent?.querySelector('product-form');

        const head = picker.querySelector('.tz-size-picker__head');
        const display = picker.querySelector('.tz-size-picker__display');
        const options = picker.querySelectorAll('.tz-size-picker__option');

        if(!head || !display || !options.length) return;
        if(!atc) return;

        const submitFormInput = atc.querySelector('input[type="hidden"][name="id"]');

        if(!submitFormInput) return;

        options.forEach(option =>
            option.addEventListener('click', () => {
                this.handleOptionSelect(picker, option, display, submitFormInput)
            })
        );

        head.addEventListener('click', (event) => { this.toggleMenu(picker)});
    }

    handleDocumentClick = (event) => {
        this.variantPickers.forEach(picker => {
            if (!picker.contains(event.target)) {
                picker.setAttribute('aria-expanded', 'false');
            }
        });
    }

    handleOptionSelect(picker, option, display, formInput) {
        const variantID = option.getAttribute('data-variant-id');
        const optionName = option.querySelector('.tz-size-picker__option-name');

        if(optionName) display.innerHTML = optionName.innerHTML.trim();
        if(formInput) formInput.value = variantID;

        // console.log("Option Name:", optionName, "VariantID:", variantID);

        this.toggleMenu(picker);
    }

    toggleMenu(picker) {
        // console.log(picker)
        const state = picker.getAttribute('aria-expanded') === 'true';
        picker.setAttribute('aria-expanded', !state);   
    }
}

if (!customElements.get('tz-upsell-colors-cart')) {
    customElements.define('tz-upsell-colors-cart', TZUpsellColorsCart);
}